import { useAPIRequest } from '~/composables/api/useAPIRequest'
import getEstateApiBaseUrl from '~/utils/getEstateApiBaseUrl'
import type { EstateDetailInterface } from '~/types/api/EstateDetail'

export async function useEstateClosestData(options: {
  estateData: EstateDetailInterface
  config?: Record<string, any>
}) {
  const baseApiUrl = getEstateApiBaseUrl(options.estateData.type)
  const config = {
    ...(options.config ?? {}),
  }

  return await useAPIRequest(
    `${baseApiUrl}/closest/${options.estateData.id}`,
    config
  )
}
